module.exports = __webpack_public_path__ + "media/partners/coty-inc-vector-7e3be57e.svg";